import { render, staticRenderFns } from "./LifeGroupTab.vue?vue&type=template&id=0c718bac&scoped=true&"
import script from "./LifeGroupTab.vue?vue&type=script&lang=js&"
export * from "./LifeGroupTab.vue?vue&type=script&lang=js&"
import style0 from "./LifeGroupTab.vue?vue&type=style&index=0&id=0c718bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c718bac",
  null
  
)

export default component.exports